module.exports = __webpack_public_path__ + "static/media/01_e_photo.01997d01.jpg";